<template>
  <div class="main">
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据大屏</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div class="main-title">
      <el-card id="infoChart"  style="height: 400px" class="main-content"></el-card>
      <!-- <el-card id="onlineListChart" :style="{ height: count + 'px' }" class="main-content"></el-card> -->
       <el-card id="onlineListChart" style="height: 400px" class="main-content"></el-card>
    </div>

      <el-card class="pbox">
        <div class="online">
          <div>在线数量统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in title" :key="item" @click="onlineClick(index)" :class="[index === onlineIndex ? 'active' : '', loading.online ? 'is-loading' : '']">{{item}}</span>
          </div>
        </div>
        <div id="onlineCountChart" style="height: 300px"></div>
      </el-card>
      <el-card class="pbox">
        <div class="online">
          <div>登录次数统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in title" :key="item" @click="loginClick(index)" :class="[index === loginIndex ? 'active' : '', loading.login ? 'is-loading' : '']">{{item}}</span>
          </div>
        </div>
        <div id="loginCountChart" style="height: 300px"></div>
      </el-card>
      <el-card class="pbox">
        <div class="online">
          <div>激活卡密数量统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in activeTitle" :key="item" @click="activeClick(index)" :class="[index === activeIndex ? 'active' : '', loading.active ? 'is-loading' : '']">{{item}}</span>
          </div>
        </div>
        <div id="activateCountChart" style="height: 300px"></div>
      </el-card>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      loading: {
        online: false,
        login: false,
        active: false
      },
      state: false,
      inputWidth: false,
      allSoftName: [],
      email: this.$store.state.account,
      queryInfo: "",
      count: 400,
      onlineNum: [],
      onlineAgainNum: [],
      censusTime: [],
      selfSeries: [],
      censusLoginTime: [],
      selfLoginSeries: [],
      censusActiveTime: [],
      selfActiveSeries: [],
      title:['今天','昨天','近7天','近30天'],
      activeTitle: ['近7天', '近30天'],
      // activeTitle: ['近7天', '近30天', '近90天'],
      onlineIndex: 0,
      loginIndex: 0,
      activeIndex: 0,

      result:"",

      infoOption: {
        color: "#2f89cf",
        title: {
          text: "总体预览",
        },

        tooltip: {
          trigger: "axis",
          // axisPointer:{
          //   type:"shadow"
          // }
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: ["卡密总量", "已使用卡密", "已过期卡密", "当前在线"],
        },
        yAxis: {},
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "35%",
            //需要请求的数据
            //data: [5, 20, 36, 10],
            data: "",
            itemStyle: {
              barBorderRadius: 5,
            },
          },
        ],
      },

      onlineListOption: {
        color: "none",
        title: {
          text: "项目详情",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "shadow",
          // },
        },
        legend: {
          data: ["总数量", "在线数"],
        },
        grid: {
          left: "20%",
          bottom: "10%",
          top: "10%",
          containLabel: false,
        },
        xAxis: {
          show: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            //data: ["按键精灵", "AJ", "ec", "触摸", "触动"],
            data: this.allSoftName,//左边项目名
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            // axisLabel:{
            //   color:'#fff'
            // }
          },
          {
            show: true,
            inverse: true,
            //data:[702,350,610,793,664],
            data: this.projectCardNum,//每个软件卡密总数
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#333",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "在线数",
            type: "bar",
            //data: [70, 34, 60, 78, 69,300],
            data: this.onlineNum,
            //data: this.onlineAgainNum,
            barCategoryGap: 50,
            barWidth: 14,
            label: {
              show: true,
              position: "inside",
              formatter: "{c}",
            },
            yAxisIndex: 0,
            itemStyle: {
              barBorderRadius: 20,
              color: function (params) {
                let myColor = ["#1089E7", "#F57474", "#56D0E3", "#F8B448", "#8B78F6"];
                let num = myColor.length;
                return myColor[params.dataIndex % num];
                //return myColor[params.dataIndex]
              },
            },
          },
          // {
          //   name: "总数量",
          //   type: "bar",
          //   stack: "总量",
          //   //data: [1000,100,100,100,100],
          //   data: this.data,
          //   //data:this.projectCardNum,
          //   barCategoryGap: 50,
          //   yAxisIndex: 1,
          //   barWidth: 15,
          //   itemStyle: {
          //     barBorderRadius: 15,
          //     color: "none",
          //     borderColor: "#00c1de",
          //     borderWidth: 3,
          //   },
          // },
        ]
      },

      onlineCountOption :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfSeries,
      },

      loginCountOption :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusLoginTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfLoginSeries,
      },

      activateCountOption :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusActiveTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfActiveSeries,
      },
      charts:{}
    };
  },
  created() {
    this.$bus.$off("yidongreloadso");
    this.$bus.$off("pcreloadso");
  },
  async mounted() {
    this.charts.onlineCountChart = this.$echarts.init(document.getElementById("onlineCountChart"));
    this.charts.loginCountChart = this.$echarts.init(document.getElementById("loginCountChart"));
    this.charts.activateCountChart = this.$echarts.init(document.getElementById("activateCountChart"));
    await this.getInfo();
    await this.getOnline();
    await this.getLoginLog();
    await this.getActiveLog();
    this.loadEcharts();
  },
  
  methods: {
    loadEcharts(){
      let infoChart = this.$echarts.init(document.getElementById("infoChart"));
      this.infoOption.series[0].data = this.result;
      // 使用刚指定的配置项和数据显示图表。
      infoChart.setOption(this.infoOption);
      window.addEventListener("resize", function () {
        infoChart.resize();
      });
      

      let onlineListChart = this.$echarts.init(document.getElementById("onlineListChart"));
      this.onlineListOption.yAxis[0].data = this.allSoftName;
      // this.onlineListOption.yAxis[1].data = this.projectCardNum;
      this.onlineListOption.series[0].data = this.onlineNum
      // console.log("this.onlineList:",this.onlineList);
      onlineListChart.setOption(this.onlineListOption);
      window.addEventListener("resize", function () {
        onlineListChart.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   onlineListChart.setOption(this.onlineListOption);
      //   window.addEventListener("resize", function () {
      //     onlineListChart.resize();
      //   });
      // });

      // let series2 = [//每个项目对应的数据
      //   {
      //     name: "梦幻西游",
      //     type: "line",
      //     //stack: "总量",
      //     data: [120, 132, 101, 134, 90, 230, 210],
      //     smooth: true,
      //   },
      // ];
      let onlineCountChart = this.$echarts.init(document.getElementById("onlineCountChart"));
      onlineCountChart.setOption(this.onlineCountOption);
      window.addEventListener("resize", function () {
        onlineCountChart.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   onlineCountChart.setOption(this.onlineCountOption);
      //   window.addEventListener("resize", function () {
      //     onlineCountChart.resize();
      //   });
      // });

      let loginCountChart = this.$echarts.init(document.getElementById("loginCountChart"));
      loginCountChart.setOption(this.loginCountOption);
      window.addEventListener("resize", function () {
        loginCountChart.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   loginCountChart.setOption(this.loginCountOption);
      //   window.addEventListener("resize", function () {
      //     loginCountChart.resize();
      //   });
      // });

      let activateCountChart = this.$echarts.init(document.getElementById("activateCountChart"));
      activateCountChart.setOption(this.activateCountOption);
      window.addEventListener("resize", function () {
        activateCountChart.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   activateCountChart.setOption(this.activateCountOption);
      //   window.addEventListener("resize", function () {
      //     activateCountChart.resize();
      //   });
      // });

      this.$bus.$on("yidongreloadso", (fruit)=> {
        if (fruit && this.$route.path == "/datascreen") {
          let infoChart = this.$echarts.init(document.getElementById("infoChart"));
          let onlineListChart = this.$echarts.init(document.getElementById("onlineListChart"));
          let onlineCountChart = this.$echarts.init(document.getElementById("onlineCountChart"));
          let loginCountChart = this.$echarts.init(document.getElementById("loginCountChart"));
          let activateCountChart = this.$echarts.init(document.getElementById("activateCountChart"));
          // console.log("this.option:",this.option);
          infoChart.setOption(this.infoOption);
          onlineListChart.setOption(this.onlineListOption);
          onlineCountChart.setOption(this.onlineCountOption);
          loginCountChart.setOption(this.loginCountOption);
          activateCountChart.setOption(this.activateCountOption);
          setTimeout(()=> {
            // console.log("手机重新渲染");
            infoChart.resize();
            onlineListChart.resize();
            onlineCountChart.resize();
            loginCountChart.resize();
            activateCountChart.resize();
          },10)
        }
      });
      this.$bus.$on("pcreloadso", (fruit)=> {
        // console.log("====this.$route.path:",this.$route.path);
        if (this.$route.path == "/datascreen") {
          let infoChart = this.$echarts.init(document.getElementById("infoChart"));
          let onlineListChart = this.$echarts.init(document.getElementById("onlineListChart"));
          let onlineCountChart = this.$echarts.init(document.getElementById("onlineCountChart"));
          let loginCountChart = this.$echarts.init(document.getElementById("loginCountChart"));
          let activateCountChart = this.$echarts.init(document.getElementById("activateCountChart"));
          // console.log("this.option:",this.option);
          infoChart.setOption(this.infoOption);
          onlineListChart.setOption(this.onlineListOption);
          onlineCountChart.setOption(this.onlineCountOption);
          loginCountChart.setOption(this.loginCountOption);
          activateCountChart.setOption(this.activateCountOption);
          setTimeout(()=> {
            // console.log("pc重新渲染");
            infoChart.resize();
            onlineListChart.resize();
            onlineCountChart.resize();
            loginCountChart.resize();
            activateCountChart.resize();
          },200)
        }
      });
    },
    async getInfo(){
      this.state = true;
      const result = await this.$http.get("info", {
        params: {
          email: this.email,
        },
      });
      this.state = false;
      console.log('result--->',result);
      this.allSoftName = result.data.data.resolve.allSoftName.map((element) => {
        return element.softName;
      });
      // console.log(this.allSoftName);
      result.data.data.resolve.allSoftName.forEach((element) => {
        if (element.num) {
          this.onlineNum.push(parseInt(element.num));
        } else {
          this.onlineNum.push(0);
        }
      });
      //console.log('onlineAgainNum',this.onlineAgainNum);
      this.result = result.data.data.result;
      console.log("2this.result",this.result);
      //console.log('result.data.data.result',result.data.data.result);
      this.projectCardNum = result.data.data.resolve.projectCardPasswordNum;
      //console.log('this.projectCardNum',this.projectCardNum);
      for (let i = 0; i < this.projectCardNum.length; i++) {
        if (this.projectCardNum[i] !== 0) {
          let res = this.onlineNum[i] / this.projectCardNum[i];
          this.onlineAgainNum.push(res);
        } else {
          this.onlineAgainNum.push(0);
        }
      }
      this.data = [];
      for (let i = 0; i < this.allSoftName.length; i++) {
        this.data.push(100);
      }
      return this.data;
    },
    async getOnline(dateType = 'today'){
      this.charts.onlineCountChart.showLoading();
      let online = await this.$http.get("online", {
        params: {
          email: this.email,
        },
      });
      console.log('online=',online);

      const processedData = this.fillMissingData(online.data.data, dateType, "online", this.allSoftName);
      //console.log("processedData=",processedData);
      
      for(let i = 0; i < processedData.length; i++){
        this.censusTime.push(processedData[i].createDate);
        if(this.selfSeries.indexOf(processedData[i].softName) === -1){
          this.selfSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      
      this.censusTime = this.unique(this.censusTime)
      // console.log('this.censusTime',this.censusTime);
      let result1 = [];
      let obj = {};
      for(let i =0; i < this.selfSeries.length; i++){
        if(!obj[this.selfSeries[i].name]){
          result1.push(this.selfSeries[i]);
          obj[this.selfSeries[i].name] = true;
        }
      }
      this.selfSeries = result1
      //console.log('this.selfSeries',this.selfSeries);
      for(let i = 0; i < processedData.length; i++){
        //console.log('processedData[i].softName',processedData[i].softName);
        for(let j = 0; j < this.selfSeries.length; j++){
          if(processedData[i].softName === this.selfSeries[j].name){
            this.selfSeries[j].data.push(processedData[i].online)
          }
        }
      }
      console.log('this.selfSeries',this.selfSeries);
      this.$set(this.onlineCountOption, 'series', this.selfSeries)
      this.$set(this.onlineCountOption.xAxis, 'data', this.censusTime)
      this.charts.onlineCountChart.hideLoading();
    },
    async getLoginLog(dateType = 'today'){
      this.charts.loginCountChart.showLoading()
      const login = await this.$http.get("logins", {
        params: {
          email: this.email,
        },
      });
      console.log('login----',login);
      const processedData = this.fillMissingData(login.data.data, dateType, "login", this.allSoftName);
      for(let i = 0; i < processedData.length; i++){
        this.censusLoginTime.push(processedData[i].createDate);
        if(this.selfLoginSeries.indexOf(processedData[i].softName) === -1){
          this.selfLoginSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      this.censusLoginTime = this.unique(this.censusLoginTime)
      let result2 = [];
      let obj2 = {};
      for(let i =0; i < this.selfLoginSeries.length; i++){
        if(!obj2[this.selfLoginSeries[i].name]){
          result2.push(this.selfLoginSeries[i]);
          obj2[this.selfLoginSeries[i].name] = true;
        }
      }
      this.selfLoginSeries = result2
      //console.log('this.selfLoginSeries',this.selfLoginSeries);
      for(let i = 0; i < processedData.length; i++){
        //console.log('processedData[i].softName',processedData[i].softName);
        for(let j = 0; j < this.selfLoginSeries.length; j++){
          if(processedData[i].softName === this.selfLoginSeries[j].name){
            this.selfLoginSeries[j].data.push(processedData[i].login)
          }
        }
      }
      this.$set(this.loginCountOption, 'series', this.selfLoginSeries)
      this.$set(this.loginCountOption.xAxis, 'data', this.censusLoginTime)
      this.charts.loginCountChart.hideLoading();
    },

    async getActiveLog(){
      this.charts.activateCountChart.showLoading()
      const active = await this.$http.get("activLog", {
        params: {
          email: this.email,
        },
      });
      console.log('active----',active);
      const processedData = this.fillMissingDataByDay(active.data.data, 'week', "active", this.allSoftName);
      // console.log("processedData=",processedData);
      for(let i = 0; i < processedData.length; i++){
        this.censusActiveTime.push(processedData[i].createDate);
        
        if(this.selfLoginSeries.indexOf(processedData[i].softName) === -1){
          this.selfActiveSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      this.censusActiveTime = this.unique(this.censusActiveTime)
      let result3 = [];
      let obj3 = {};
      for(let i =0; i < this.selfActiveSeries.length; i++){
        if(!obj3[this.selfActiveSeries[i].name]){
          result3.push(this.selfActiveSeries[i]);
          obj3[this.selfActiveSeries[i].name] = true;
        }
      }
      this.selfActiveSeries = result3
      //console.log('this.selfActiveSeries',this.selfActiveSeries);
      for(let i = 0; i < processedData.length; i++){
        //console.log('processedData[i].softName',processedData[i].softName);
        for(let j = 0; j < this.selfActiveSeries.length; j++){
          if(processedData[i].softName === this.selfActiveSeries[j].name){
            this.selfActiveSeries[j].data.push(processedData[i].active)
          }
        }
      }
      this.$set(this.activateCountOption, 'series', this.selfActiveSeries)
      this.$set(this.activateCountOption.xAxis, 'data', this.censusActiveTime)
      this.charts.activateCountChart.hideLoading()
    },
    


    async getCardTypeSoftName() {
      this.state = true;
      // const result = await this.$http.post("cardGetSoft", {
      //   email: this.email,
      // });
      const result = await this.$http.get("info", {
        params: {
          email: this.email,
        },
      });
      this.state = false;
      console.log(result);
      this.allSoftName = result.data.data.resolve.allSoftName.map((element) => {
        return element.softName;
      });
      //console.log(this.allSoftName);
      window.sessionStorage.setItem("allSoftName", this.allSoftName);
      this.count = this.allSoftName.length * 30;
      console.log("this.count", this.count);
      window.sessionStorage.setItem("count", this.count);
      this.result = result.data.data.result;
      window.sessionStorage.setItem("result", this.result);
      this.projectCardNum = result.data.data.resolve.projectCardPasswordNum;
      window.sessionStorage.setItem("projectCardNum", this.projectCardNum);
    },
    
    unique(arr){
      let arr1 = [];       // 新建一个数组来存放arr中的值
      for(let i=0,len=arr.length;i<len;i++){
        if(arr1.indexOf(arr[i]) === -1){
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
    async onlineClick(index){
      if(this.onlineIndex !== index){
        this.loading.online = true
        this.charts.onlineCountChart.showLoading()
        console.log(index);
        this.censusTime = [],
        this.selfSeries = [],
        this.onlineIndex = index
        const online = await this.$http.get("online", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('online--',online);
        let processedData
        if (index == 0) {
          processedData = this.fillMissingData(online.data.data, 'today', "online", this.allSoftName);
        }else if (index == 1) {
          processedData = this.fillMissingData(online.data.data, 'yesterday', "online", this.allSoftName);
        }else if(index == 2){
          processedData = this.fillMissingData(online.data.data, 'week', "online", this.allSoftName)
        }else if(index == 3){
          processedData = this.fillMissingData(online.data.data, 'month', "online", this.allSoftName)
        }        
        for(let i = 0; i < processedData.length; i++){
          this.censusTime.push(processedData[i].createDate);
          
          if(this.selfSeries.indexOf(processedData[i].softName) === -1){
            this.selfSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        //console.log('this.censusTime',this.censusTime);
        // console.log('this.selfSeries',this.selfSeries);
        this.censusTime = this.unique(this.censusTime)
        //console.log('this.censusTime',this.censusTime);
        let result1 = [];
        let obj = {};
        for(let i =0; i < this.selfSeries.length; i++){
          if(!obj[this.selfSeries[i].name]){
            result1.push(this.selfSeries[i]);
            obj[this.selfSeries[i].name] = true;
          }
        }
        this.selfSeries = result1
        //console.log('this.selfSeries',this.selfSeries);
        for(let i = 0; i < processedData.length; i++){
          //console.log('processedData[i].softName',processedData[i].softName);
          for(let j = 0; j < this.selfSeries.length; j++){
            if(processedData[i].softName === this.selfSeries[j].name){
              this.selfSeries[j].data.push(processedData[i].online)
            }
          }
        }
        this.$set(this.onlineCountOption, 'series', this.selfSeries)
        this.$set(this.onlineCountOption.xAxis, 'data', this.censusTime)
        this.$emit("reloadso")

        console.log("点击了在线数量--");
        // ✅ 新增：手动更新在线数量图表
        const onlineCountChart = this.$echarts.init(document.getElementById("onlineCountChart"));
        onlineCountChart.setOption(this.onlineCountOption, true); // true 表示不合并旧配置，完全覆盖
        window.addEventListener("resize", () => onlineCountChart.resize());
        this.charts.onlineCountChart.hideLoading()
        this.loading.online = false
      }
    },

    async loginClick(index){
      if(this.loginIndex !== index){
        console.log(index);
        this.loading.login = true;
        this.charts.loginCountChart.showLoading()
        this.censusLoginTime = [],
        this.selfLoginSeries = [],
        this.loginIndex = index
        const login = await this.$http.get("logins", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('login----',login);
        let processedData
        if (index == 0) {
          processedData = this.fillMissingData(login.data.data, 'today', "login", this.allSoftName);
        }else if (index == 1) {
          processedData = this.fillMissingData(login.data.data, 'yesterday', "login", this.allSoftName);
        }else if(index == 2){
          processedData = this.fillMissingData(login.data.data, 'week', "login", this.allSoftName)
        }else if(index == 3){
          processedData = this.fillMissingData(login.data.data, 'month', "login", this.allSoftName)
        }
        for(let i = 0; i < processedData.length; i++){
          this.censusLoginTime.push(processedData[i].createDate);
          
          if(this.selfLoginSeries.indexOf(processedData[i].softName) === -1){
            this.selfLoginSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        this.censusLoginTime = this.unique(this.censusLoginTime)
        let result1 = [];
        let obj = {};
        for(let i =0; i < this.selfLoginSeries.length; i++){
          if(!obj[this.selfLoginSeries[i].name]){
            result1.push(this.selfLoginSeries[i]);
            obj[this.selfLoginSeries[i].name] = true;
          }
        }
        this.selfLoginSeries = result1
        //console.log('this.selfLoginSeries',this.selfLoginSeries);
        for(let i = 0; i < processedData.length; i++){
          //console.log('processedData[i].softName',processedData[i].softName);
          for(let j = 0; j < this.selfLoginSeries.length; j++){
            if(processedData[i].softName === this.selfLoginSeries[j].name){
              this.selfLoginSeries[j].data.push(processedData[i].login)
            }
          }
        }
        this.$set(this.loginCountOption, 'series', this.selfLoginSeries)
        this.$set(this.loginCountOption.xAxis, 'data', this.censusLoginTime)
        this.$emit("reloadso")

        console.log("点击了登录次数--");
        // ✅ 新增：手动更新登录次数图表
        const loginCountChart = this.$echarts.init(document.getElementById("loginCountChart"));
        loginCountChart.setOption(this.loginCountOption, true); // true 表示不合并旧配置，完全覆盖
        window.addEventListener("resize", () => loginCountChart.resize());
        this.charts.loginCountChart.hideLoading()
        this.loading.login = false;
      }
    },

    async activeClick(index){
      console.log("index==",index);
      
      if(this.activeIndex !== index){
        this.loading.active = true;
        this.charts.activateCountChart.showLoading()
        console.log(index);
        this.censusActiveTime = [],
        this.selfActiveSeries = [],
        this.activeIndex = index
        const active = await this.$http.get("activLog", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('active----',active);
        let processedData
        if (index == 0) {
          processedData = this.fillMissingDataByDay(active.data.data, 'week', "active", this.allSoftName);
          // console.log("processedData="&processedData);
        }else if(index == 1){
          processedData = this.fillMissingDataByDay(active.data.data, '', "active", this.allSoftName);
          // console.log("processedData="&processedData);
        }
        
        
        for(let i = 0; i < processedData.length; i++){
          this.censusActiveTime.push(processedData[i].createDate);
          
          if(this.selfLoginSeries.indexOf(processedData[i].softName) === -1){
            this.selfActiveSeries.push({name: processedData[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        this.censusActiveTime = this.unique(this.censusActiveTime)
        let result3 = [];
        let obj3 = {};
        for(let i =0; i < this.selfActiveSeries.length; i++){
          if(!obj3[this.selfActiveSeries[i].name]){
            result3.push(this.selfActiveSeries[i]);
            obj3[this.selfActiveSeries[i].name] = true;
          }
        }
        this.selfActiveSeries = result3
        //console.log('this.selfActiveSeries',this.selfActiveSeries);
        for(let i = 0; i < processedData.length; i++){
          //console.log('processedData[i].softName',processedData[i].softName);
          for(let j = 0; j < this.selfActiveSeries.length; j++){
            if(processedData[i].softName === this.selfActiveSeries[j].name){
              this.selfActiveSeries[j].data.push(processedData[i].active)
            }
          }
        }
        this.$set(this.activateCountOption, 'series', this.selfActiveSeries)
        this.$set(this.activateCountOption.xAxis, 'data', this.censusActiveTime)
        this.$emit("reloadActive")

        console.log("点击了激活数量--");
        // ✅ 新增：手动更新激活数量图表
        const activateCountChart = this.$echarts.init(document.getElementById("activateCountChart"));
        activateCountChart.setOption(this.activateCountOption, true); // true 表示不合并旧配置，完全覆盖
        window.addEventListener("resize", () => activateCountChart.resize());
        this.charts.activateCountChart.hideLoading()
        this.loading.active = false;
      }
    },
    /**
     * 补全时间轴数据的通用函数
     * @param {Array} rawData - 接口返回的原始数组
     * @param {String} dateType - 类型: 'today', 'yesterday', 'week', 'month'
     * @param {String} type - 类型: 'online', 'login'
     */
    fillMissingData(rawData, dateType, type, fixedSoftNames) {
      const now = moment();
      let timeAxis = [];
      const format = 'YYYY-MM-DD HH:00'; 
      let daysToSubtract = 0;
      if (dateType === 'today') {
        const currentHour = now.hour();
        timeAxis = Array.from({ length: currentHour + 1 }, (_, i) => 
          now.clone().startOf('day').add(i, 'hours').format(format)
        );
      } else if (dateType === 'yesterday') {
        const yesterday = now.clone().subtract(1, 'days').startOf('day');
        timeAxis = Array.from({ length: 24 }, (_, i) => 
          yesterday.clone().add(i, 'hours').format(format)
        );
      } else {
        daysToSubtract = (dateType === 'week') ? 6 : 29;
        const start = now.clone().subtract(daysToSubtract, 'days').startOf('day');
        const hoursCount = now.diff(start, 'hours') + 1; 
        timeAxis = Array.from({ length: hoursCount }, (_, i) => 
          start.clone().add(i, 'hours').format(format)
        );
      }
      //const allSoftNames = Array.from(new Set(rawData.map(item => item.softName)));
      const allSoftNames = fixedSoftNames || Array.from(new Set(rawData.map(item => item.softName)));
      const dataMap = new Map();
      rawData.forEach(item => {
        const dateKey = moment(item.createDate).format(format);
        if (!dataMap.has(dateKey)) dataMap.set(dateKey, new Map());
        dataMap.get(dateKey).set(item.softName, item[type] || 0);
      });
      const result = [];
      timeAxis.forEach(time => {
        allSoftNames.forEach(name => {
          const value = (dataMap.has(time) && dataMap.get(time).has(name)) 
            ? dataMap.get(time).get(name) 
            : 0;
          
          result.push({
            softName: name,
            createDate: time,
            [type]: value 
          });
        });
      });
      return result;
    },
    fillMissingDataByDay(rawData, dateType, type, fixedSoftNames) {
      const now = moment();
      let timeAxis = [];
      const format = 'YYYY-MM-DD'; // 格式改为按天

      // 1. 生成按天的日期轴
      const days = (dateType === 'week') ? 7 : 30; // 近7天或30天
      for (let i = days - 1; i >= 0; i--) {
        timeAxis.push(now.clone().subtract(i, 'days').format(format));
      }

      // 2. 数据分组逻辑：按日期和软件名称作为唯一键
      const dataMap = new Map();
      rawData.forEach(item => {
        const dateKey = moment(item.createDate).format(format);
        if (!dataMap.has(dateKey)) dataMap.set(dateKey, new Map());
        dataMap.get(dateKey).set(item.softName, item[type] || 0);
      });

      // 3. 构建结果：填充缺失的天数和缺失的软件
      const result = [];
      timeAxis.forEach(date => {
        fixedSoftNames.forEach(name => {
          const value = (dataMap.has(date) && dataMap.get(date).has(name)) 
            ? dataMap.get(date).get(name) 
            : 0; // 缺失则补 0
          
          result.push({
            softName: name,
            createDate: date,
            [type]: value 
          });
        });
      });

      return result;
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  // margin: 20px;
  .el-select {
    margin-left: 10px;
  }
  .nav {
    margin: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .main-content {
    //margin: 0 16px 20px 0;
    position: relative;
    .info {
      margin-top: 5px;
      font-size: 30px;
    }
    .title {
      font-size: 14px;
      color: rgb(158, 157, 157);
    }
  }
  i {
    font-size: 50px;
  }
  .el-tooltip {
    font-size: 16px;
    position: absolute;
    top: 20px;
    right: 10px;
    cursor: pointer;
  }
}
//这句话的意思: 在我们屏幕上 并且 最小的宽度是 1600相似 设置我们想要的样式
// @media screen and (min-width: 1600px) {
@media screen and (min-width: 1200px) {
//   //一排
  .main-title {
    display: flex;

    .el-card{
      width: 50%;
    }
  }
  // .main-content {
  //   width: 55%;
  // }
  // .main-title-children {
  //   width: 50%;
  //   display: flex;
  // }
  // .el-card .last-end {
  //   margin-right: 0;
  // }
  #main #onlineList #onlineCountChart {
  padding: 10px 10px 0 5px;
  //background-image: url('../assets/bg.jpg');
  // background-color: #00264a;
  }

  #main {
    margin-right: 5px;
    margin-bottom: 10px;
  }
  #onlineList {
    margin-left: 5px;
    margin-bottom: 10px;
  }
  #onlineCountChart {
    //margin-right: 5px;
    margin-bottom: 20px;
  }
}

// @media screen and (min-width: 576px) and (max-width: 1599px) {
  @media screen and (min-width: 768px) and (max-width: 1199px) {
  .main-title {
    display: flex;
    .el-card{
      width: 50%;
    }
  }
//   //两排
//   // .main-title{
//   //   display: flex;
//   //   flex-wrap: wrap;
//   // }
//   .main-title-children {
//     width: 100%;
//     display: flex;
//   }
//   .main-content {
//     width: 50%;
//   }
//   .main-content:nth-child(4) {
//     margin-right: 0;
//   }
//   .main-content:nth-child(2) {
//     margin-right: 0;
//   }
#main #onlineList #onlineCountChart {
  padding: 10px 10px 0 5px;
  //background-image: url('../assets/bg.jpg');
  // background-color: #00264a;
}

#main {
  margin-right: 5px;
  margin-bottom: 10px;
}
#onlineList {
  margin-left: 5px;
  margin-bottom: 10px;
}
#onlineCountChart {
  //margin-right: 5px;
  margin-bottom: 20px;
}
}

// @media screen and (max-width: 575px) {
@media screen and (max-width: 767px) and (min-width:480px) {
  //四排
  .main-content {
    width: 100%;
    display: flex;
    
  }
  #onlineList{
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-col{
    margin: 10 0px 10px 10px;
  }
  .pbox{
    // margin: 0 0 10px 10px;
    margin: 10 0px 10px 10px !important;
    width: 100%;
  }
}

.main-title {
  margin: 5px 5px 0 5px;
  .el-card {
    padding: 10px 10px 0px 10px;
  }
}


.pbox {
  font: bold 18px/1.5em "Microsoft YaHei";
  margin: 0 5px 5px 5px;
  // display: flex;
  // width: 100%;

  // border: 1px solid deeppink;
  // overflow: hidden;
}

.online{
  display: flex;
  justify-content: space-between;
  .datelable{
    font-weight: 400;
    font-size: 13px;
  }
  span{
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 2px 10px;
    cursor: pointer;
  }
  // label{
  //   border: 1px solid #d9d9d9;
  //   border-radius: 5px;
  //   padding: 2px 10px;
  //   cursor: pointer;
  // }
  .active{
    background-color: #1890ff;
    color:#fff
  }
}
/* 基础样式 */
.datelable span {
  cursor: pointer;
  padding: 5px 10px;
  transition: all 0.3s;
}

/* 加载中的样式 */
.datelable span.is-loading {
  pointer-events: none; /* 禁止再次点击 */
  opacity: 0.6;         /* 变灰 */
  cursor: not-allowed;
}

/* 加载中的旋转动画 */
.datelable span.is-loading::after {
  content: " ↻"; /* 也可以换成图标字体 */
  display: inline-block;
  animation: loading-rotate 1s linear infinite;
}

@keyframes loading-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>